import React, { Suspense } from "react";

import MarketingRequests from "../EnhancedInsights/ProductsByAccount/MarketingRequests";
import { Grid, withStyles } from "@material-ui/core";


const styles = (theme) => ({
  dashOuter: {
    display: "flex",
    flexGrow: 1,
    margin: "auto",
  },
  dashInner: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
  },
  graph1: {
    flexGrow: 1,
    height: 250,
    margin: 10,
  },
});
const MarketingRequestsRoutes = (props) => {
  const { classes } = props;

  return (
    <>
      

      
      
    {props.location === "Marketing Support Requests" && (
        <Grid container spacing={3} className={classes.grid}>
          <Grid item xs={12} style={{ padding: "0px" }}>
            <MarketingRequests />
          </Grid>
        </Grid>
      )}
    </>
  );
};


export default withStyles(styles)(MarketingRequestsRoutes);
